import { render, staticRenderFns } from "./geral.vue?vue&type=template&id=16e9e493&scoped=true&"
import script from "./geral.vue?vue&type=script&lang=js&"
export * from "./geral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e9e493",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/consulta-nfe/geral.vue
// module id = 266
// module chunks = 1